import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

const ink = '#1a1a2e';
const notVariant = { shouldForwardProp: (prop) => prop !== '$variant' && prop !== '$color' };

export const TileRow = styled(Box, notVariant)(({ $variant }) =>
  $variant === 'icon'
    ? {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        gap: 14,
        '@media (max-width: 900px)': {
          display: 'flex',
          justifyContent: 'flex-start',
          gap: 10,
          paddingBottom: 6,
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        },
      }
    : {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 10,
        marginTop: 18,
      },
);

export const TradeTile = styled(ButtonBase, notVariant)(({ $variant }) =>
  $variant === 'icon'
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 10,
        padding: '18px 16px',
        borderRadius: 18,
        textAlign: 'left',
        fontFamily: 'inherit',
        fontSize: '1.02rem',
        fontWeight: 700,
        color: ink,
        background: '#ffffff',
        border: '1px solid rgba(26, 26, 46, 0.07)',
        boxShadow: '0 2px 10px rgba(26, 26, 46, 0.04)',
        scrollSnapAlign: 'start',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        '&:hover, &.Mui-focusVisible': {
          borderColor: 'rgba(13, 78, 254, 0.3)',
          boxShadow: '0 10px 24px rgba(13, 78, 254, 0.1)',
          transform: 'translateY(-2px)',
        },
        '@media (max-width: 900px)': {
          flex: '0 0 auto',
          width: 160,
        },
        '@media (max-width: 600px)': {
          width: 142,
          padding: '14px 12px',
          fontSize: '0.95rem',
        },
      }
    : {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '9px 16px 9px 10px',
        borderRadius: 999,
        border: '1px solid rgba(0, 0, 0, 0.08)',
        background: '#ffffff',
        fontFamily: 'inherit',
        fontSize: '0.92rem',
        fontWeight: 600,
        color: ink,
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease',
        '&:hover, &.Mui-focusVisible': {
          borderColor: 'rgba(13, 78, 254, 0.35)',
          boxShadow: '0 4px 14px rgba(13, 78, 254, 0.12)',
          transform: 'translateY(-1px)',
        },
      },
);

export const TileIcon = styled('span', notVariant)(({ $variant, $color }) => {
  const isIcon = $variant === 'icon';
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: isIcon ? 48 : 30,
    height: isIcon ? 48 : 30,
    borderRadius: isIcon ? 14 : '50%',
    color: $color,
    background: isIcon ? `${$color}1f` : `${$color}1f`,
    '& svg': { fontSize: isIcon ? 26 : 18 },
  };
});

export const TileLabel = styled('span')({
  lineHeight: 1.25,
});

export const TileHint = styled('span')({
  marginTop: -4,
  fontSize: '0.86rem',
  fontWeight: 500,
  lineHeight: 1.4,
  color: '#5a6478',
});
